import { queryOptions } from "@tanstack/react-query";

import { apiFetch } from "../lib/api";
import type {
  AdvisorSignalListResponse,
  ExcelImportStartRequest,
  ExcelImportStartResponse,
  RegisterFileSourceCreateRequest,
  RegisterFileSourceCreateResponse,
  RegisterFileSourceListResponse,
  RegisterFileSourcePreviewRequest,
  RegisterFileSourcePreviewResponse,
  RegisterFileSourceUploadImportResponse,
  RegisterFileSourceUploadPreviewResponse,
  SignalApplyResponse,
} from "./types";

export const advisorSignalsQueryOptions = queryOptions({
  queryKey: ["bootstrap", "advisor-signals"] as const,
  queryFn: () =>
    apiFetch<AdvisorSignalListResponse>("/register/advisor-signals"),
});

export function applyAdvisorSignal(
  signalId: string,
): Promise<SignalApplyResponse> {
  return apiFetch<SignalApplyResponse>(
    `/register/advisor-signals/${signalId}/apply`,
    { method: "POST" },
  );
}

export function startExcelImport(
  request: ExcelImportStartRequest,
): Promise<ExcelImportStartResponse> {
  return apiFetch<ExcelImportStartResponse>("/register/excel-imports", {
    method: "POST",
    body: JSON.stringify(request),
  });
}

export const registerFileSourcesQueryOptions = queryOptions({
  queryKey: ["bootstrap", "register-file-sources"] as const,
  queryFn: () =>
    apiFetch<RegisterFileSourceListResponse>("/register/file-sources"),
});

export function previewRegisterFileSource(
  request: RegisterFileSourcePreviewRequest,
): Promise<RegisterFileSourcePreviewResponse> {
  return apiFetch<RegisterFileSourcePreviewResponse>(
    "/register/file-sources/preview",
    {
      method: "POST",
      body: JSON.stringify(request),
    },
  );
}

export function createRegisterFileSource(
  request: RegisterFileSourceCreateRequest,
): Promise<RegisterFileSourceCreateResponse> {
  return apiFetch<RegisterFileSourceCreateResponse>("/register/file-sources", {
    method: "POST",
    body: JSON.stringify(request),
  });
}

export function previewRegisterFileSourceUpload(
  file: File,
): Promise<RegisterFileSourceUploadPreviewResponse> {
  const form = new FormData();
  form.append("file", file);
  return apiFetch<RegisterFileSourceUploadPreviewResponse>(
    "/register/file-sources/preview-upload",
    { method: "POST", body: form },
  );
}

export function importRegisterFileSourceUpload(
  file: File,
  columnMapping: Record<string, string>,
): Promise<RegisterFileSourceUploadImportResponse> {
  const form = new FormData();
  form.append("file", file);
  form.append("column_mapping", JSON.stringify(columnMapping));
  return apiFetch<RegisterFileSourceUploadImportResponse>(
    "/register/file-sources/import-upload",
    { method: "POST", body: form },
  );
}
